import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import * as constatnts from "../../Constatnts";
import { isNullOrUndefined } from "util";
import Loader from "../Loader";
import ReactHtmlParser from "react-html-parser";
import firebase from "../../firebase";
import Pagination from "react-js-pagination";

class InvoiceDetailList1 extends Component {
  constructor() {
    super();
    this.state = {
      taxes: [
        { name: "CGST", perc: "CGST%" },
        { name: "SGST", perc: "SGST%" },
        { name: "IGST", perc: "IGST%" },
        { name: "CESS", perc: "CESS%" },
      ],
      invoices: [],
      stores: [],
      storeList: [],
      searchText: "",
      searchTransactionNo: "",
      searchTransactiontype: "",
      searchTransactionFromDate: new Date().toISOString().split("T")[0],
      searchTransactionToDate: new Date().toISOString().split("T")[0],
      searchCustomerDetail: "",
      searchProductDetail: "",
      //   searchDiscount: "",
      //   searchTaxableAmount: "",
      //   searchTaxSummary: "",
      activePage: 1,
      itemsCountPerPage: 100,
      totalItemsCount: 0,
      recordFrom: 0,
      title: "",
      paginationStatus: "No records to display",
      exportCalled: false,
      loading: true,
      productCustomField1DisplayName: "Custom Field 1",
      productCustomField2DisplayName: "Custom Field 2",
      productCustomField3DisplayName: "Custom Field 3",
      productCustomField4DisplayName: "Custom Field 4",
      productCustomField5DisplayName: "Custom Field 5",
      productCustomField6DisplayName: "Custom Field 6",
      gstinCustomFieldNo: 0,
      years: [],
      months: [],
      selectedYear: 0,
      selectedMonth: 0, //
    };

    this.onClearSearch = this.onClearSearch.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.onExportClick = this.onExportClick.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.onMonthChange = this.onMonthChange.bind(this);
    this.onYearChange = this.onYearChange.bind(this);
    this.getElasticData = this.getElasticData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.showPaginationStatus = this.showPaginationStatus.bind(this);
  }

  componentDidMount() {
    let selectedYear = new Date().getFullYear();
    let selectedMonth = new Date().getMonth();
    let years = this.props.getYears();
    let months = this.props.getMonths(selectedYear);
    let searchTransactionFromDate = this.getMonthStartDate(
      selectedYear,
      selectedMonth
    );
    let searchTransactionToDate = this.getMonthEndDate(
      selectedYear,
      selectedMonth
    );
    let storeList = [];
    storeList.push({ key: this.props.user.store.key });
    this.setState({
      storeID: this.props.user.store.key,
      storeList: storeList,
      years: years,
      months: months,
      selectedYear: selectedYear,
      selectedMonth: selectedMonth,
      searchTransactionFromDate: searchTransactionFromDate,
      searchTransactionToDate: searchTransactionToDate,
    });

    this.props
      .getUserStores(this.props.user.user.RegistrationID, "")
      .then((stores) => {
        this.setState({ stores: stores });
      });

    this.props.config.CustomFields.map((customField) => {
      if (customField.ModuleName === "Customer") {
        let gstinCustomFieldNo = 0;
        if (customField.CustomField1Name.trim().toLowerCase() === "gstin") {
          gstinCustomFieldNo = 1;
        } else if (
          customField.CustomField2Name.trim().toLowerCase() === "gstin"
        ) {
          gstinCustomFieldNo = 2;
        } else if (
          customField.CustomField3Name.trim().toLowerCase() === "gstin"
        ) {
          gstinCustomFieldNo = 3;
        } else if (
          customField.CustomField4Name.trim().toLowerCase() === "gstin"
        ) {
          gstinCustomFieldNo = 4;
        } else if (
          customField.CustomField5Name.trim().toLowerCase() === "gstin"
        ) {
          gstinCustomFieldNo = 5;
        } else if (
          customField.CustomField6Name.trim().toLowerCase() === "gstin"
        ) {
          gstinCustomFieldNo = 6;
        }
        this.setState({ gstinCustomFieldNo: gstinCustomFieldNo });
      } else if (customField.ModuleName === "Product") {
        let productCustomField1DisplayName =
          customField.CustomField1Name.trim() === ""
            ? "Custom Field 1"
            : customField.CustomField1Name.trim();
        let productCustomField2DisplayName =
          customField.CustomField2Name.trim() === ""
            ? "Custom Field 2"
            : customField.CustomField2Name.trim();
        let productCustomField3DisplayName =
          customField.CustomField3Name.trim() === ""
            ? "Custom Field 3"
            : customField.CustomField3Name.trim();
        let productCustomField4DisplayName =
          customField.CustomField4Name.trim() === ""
            ? "Custom Field 4"
            : customField.CustomField4Name.trim();
        let productCustomField5DisplayName =
          customField.CustomField5Name.trim() === ""
            ? "Custom Field 5"
            : customField.CustomField5Name.trim();
        let productCustomField6DisplayName =
          customField.CustomField6Name.trim() === ""
            ? "Custom Field 6"
            : customField.CustomField6Name.trim();
        this.setState({
          productCustomField1DisplayName: productCustomField1DisplayName,
          productCustomField2DisplayName: productCustomField2DisplayName,
          productCustomField3DisplayName: productCustomField3DisplayName,
          productCustomField4DisplayName: productCustomField4DisplayName,
          productCustomField5DisplayName: productCustomField5DisplayName,
          productCustomField6DisplayName: productCustomField6DisplayName,
        });
      }
    });

    this.loadInvoiceDetailReport(
      storeList,
      this.state.recordFrom,
      this.state.itemsCountPerPage,
      this.state.searchTransactionNo,
      this.state.searchTransactiontype,
      searchTransactionFromDate,
      searchTransactionToDate,
      this.state.searchCustomerDetail,
      this.state.searchProductDetail
      //   this.state.searchDiscount,
      //   this.state.searchTaxableAmount,
      //   this.state.searchTaxSummary
    );
  }

  handlePageChange(pageNumber) {
    console.log("pageNumber", pageNumber);
    let recordFrom = (pageNumber - 1) * this.state.itemsCountPerPage;
    this.setState({ activePage: pageNumber, recordFrom: recordFrom });
    this.loadInvoiceDetailReport(
      this.state.storeList,
      recordFrom,
      this.state.itemsCountPerPage,
      this.state.searchTransactionNo,
      this.state.searchTransactiontype,
      this.state.searchTransactionFromDate,
      this.state.searchTransactionToDate,
      this.state.searchCustomerDetail,
      this.state.searchProductDetail
    );
    // this.loadInvoiceDetailReport(
    //   this.state.storeList,
    //   recordFrom,
    //   this.state.itemsCountPerPage,
    //   this.state.searchTransactionNo,
    //   this.state.searchTransactiontype,
    //   this.state.searchTransactionFromDate,
    //   this.state.searchTransactionToDate,
    //   this.state.searchCustomerDetail,
    //   this.state.searchProductDetail
    // );
  }

  showPaginationStatus() {
    // console.log('this.state.recordFrom', this.state.recordFrom)
    let paginationStatus;
    if (this.state.recordFrom + 1 === this.state.totalItemsCount) {
      paginationStatus =
        "Showing " +
        this.state.totalItemsCount +
        " of " +
        this.state.totalItemsCount;
    } else if (
      this.state.recordFrom + this.state.itemsCountPerPage + 1 >
      this.state.totalItemsCount
    ) {
      paginationStatus =
        "Showing " +
        (this.state.recordFrom + 1) +
        " to  " +
        this.state.totalItemsCount +
        " of " +
        this.state.totalItemsCount;
    } else {
      paginationStatus =
        "Showing " +
        (this.state.recordFrom + 1) +
        " to  " +
        (this.state.recordFrom + this.state.itemsCountPerPage) +
        " of " +
        this.state.totalItemsCount;
    }
    this.setState({ paginationStatus: paginationStatus });
  }

  onYearChange(evt) {
    let selectedYear = evt.target.value;
    let months = this.props.getMonths(selectedYear);
    let selectedMonth = months[months.length - 1].Month;
    let searchTransactionFromDate = this.getMonthStartDate(
      selectedYear,
      selectedMonth
    );
    let searchTransactionToDate = this.getMonthEndDate(
      selectedYear,
      selectedMonth
    );
    this.setState({
      months: months,
      selectedYear: selectedYear,
      selectedMonth: selectedMonth,
      searchTransactionFromDate: searchTransactionFromDate,
      searchTransactionToDate: searchTransactionToDate,
    });
  }

  onMonthChange(evt) {
    let selectedMonth = evt.target.value;
    let searchTransactionFromDate = this.getMonthStartDate(
      this.state.selectedYear,
      selectedMonth
    );
    let searchTransactionToDate = this.getMonthEndDate(
      this.state.selectedYear,
      selectedMonth
    );
    this.setState({
      selectedMonth: selectedMonth,
      searchTransactionFromDate: searchTransactionFromDate,
      searchTransactionToDate: searchTransactionToDate,
    });
  }

  getMonthStartDate(selectedYear, selectedMonth) {
    return this.props.getStartDateOfMonth(selectedYear, selectedMonth);
  }

  getMonthEndDate(selectedYear, selectedMonth) {
    return this.props.getEndDateOfMonth(selectedYear, selectedMonth);
  }

  getGSTINCustomField() {
    let gstinCustomFieldNo = 0;
    this.props.config.CustomFields.map((customField) => {
      if (customField.ModuleName === "Customer") {
        if (customField.CustomField1Name.trim().toLowerCase() === "gstin") {
          gstinCustomFieldNo = 1;
        } else if (
          customField.CustomField2Name.trim().toLowerCase() === "gstin"
        ) {
          gstinCustomFieldNo = 2;
        } else if (
          customField.CustomField3Name.trim().toLowerCase() === "gstin"
        ) {
          gstinCustomFieldNo = 3;
        } else if (
          customField.CustomField4Name.trim().toLowerCase() === "gstin"
        ) {
          gstinCustomFieldNo = 4;
        } else if (
          customField.CustomField5Name.trim().toLowerCase() === "gstin"
        ) {
          gstinCustomFieldNo = 5;
        } else if (
          customField.CustomField6Name.trim().toLowerCase() === "gstin"
        ) {
          gstinCustomFieldNo = 6;
        }
        this.setState({ gstinCustomFieldNo: gstinCustomFieldNo });
      }
    });
    return gstinCustomFieldNo;
  }

  async getElasticData(
    registrationID,
    searchStores,
    from,
    size,
    searchTransactionNo,
    searchTransactionType,
    searchTransactionFromDate,
    searchTransactionToDate,
    searchCustomerDetail,
    searchProductDetail,
    exportData = false
  ) {
    const fromDateStr = searchTransactionFromDate + "T00:00:00";
    // Create a Date object
    const fromDate = new Date(fromDateStr);
    // Convert the Date object to epoch milliseconds
    const epochMillisFrom = fromDate.getTime();
    // console.log(epochMillisFrom);

    // Define the date-time string
    const toDateStr = searchTransactionToDate + "T23:59:59";
    // Create a Date object
    const toDate = new Date(toDateStr);
    // Convert the Date object to epoch milliseconds
    const epochMillisTo = toDate.getTime();
    // console.log(epochMillisTo);

    // console.log("getElasticData");

    let searchParameters = {
      _source: [
        "StoreID",
        "StoreName",
        "StoreCode",
        "CashRegisterName",
        "CashRegisterCode",
        "CustomerCode",
        "CustomerName",
        "CustomerPhoneNo",
        "CustomerCustomField1",
        "CustomerCustomField2",
        "CustomerCustomField3",
        "CustomerCustomField4",
        "CustomerCustomField5",
        "CustomerCustomField6",
        "TransactionNo",
        "TransactionType",
        "TransactionDate",
        "CancellationReason",
        "ProductType",
        "HSNSACCode",
        "Brand",
        "Category",
        "SubCategory",
        "SKU",
        "BarCode",
        "ProductID",
        "ProductName",
        "ProductCustomField1",
        "ProductCustomField2",
        "ProductCustomField3",
        "ProductCustomField4",
        "ProductCustomField5",
        "ProductCustomField6",
        "MRP",
        "SupplyPrice",
        "RetailPrice",
        "Qty",
        "TaxInclusive",
        "TaxableAmount",
        "DiscountPer",
        "TaxComponentAmount",
        "SubTotal",
        "TotalTax",
        "DiscountAmount",
        "Amount",
        "UniqueNo1",
        "UniqueNo2",
        "UniqueNo3",
        "UniqueNo4",
        "BatchExpDate",
        "BatchExpDateValue",
        "BatchMRP",
        "BatchMfgDate",
        "BatchMfgDateValue",
        "BatchNo",
        "BatchRetailPrice",
        "TransactionID",
        "EmployeeName",
        "SalesChannelName",
      ],
      from: from,
      size: size,
      track_total_hits: true,
      query: {
        bool: {
          must: [
            {
              term: {
                RegistrationID: registrationID,
              },
            },
            {
              range: {
                TransactionDate: {
                  lte: epochMillisTo,
                  gte: epochMillisFrom,
                },
              },
            },
          ],
          should: [],
          minimum_should_match: 1,
          filter: {
            bool: {
              must: [],
            },
          },
        },
      },
      sort: [
        {
          TransactionDate: {
            order: "desc",
          },
        },
      ],
    };
    for (let i = 0; i < searchStores.length; i++) {
      const store = searchStores[i];

      searchParameters.query.bool.should.push({
        term: {
          "StoreID.keyword": store.key,
        },
      });
    }
    if (searchCustomerDetail.trim() !== "") {
      searchParameters.query.bool.filter.bool.must.push({
        regexp: {
          CustomerDetails:
            "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
        },
      });
    }
    if (searchProductDetail.trim() !== "") {
      searchParameters.query.bool.filter.bool.must.push({
        regexp: {
          ProductDetails: "@" + searchProductDetail.trim().toLowerCase() + ".*",
        },
      });
    }
    if (searchTransactionNo.trim() !== "") {
      searchParameters.query.bool.filter.bool.must.push({
        match_phrase: { TransactionNo: searchTransactionNo },
      });
    }
    if (searchTransactionType.trim() !== "") {
      searchParameters.query.bool.filter.bool.must.push({
        regexp: {
          TransactionTypeID: searchTransactionType.trim().toLowerCase(),
        },
      });
    }
    // if (searchBrand.trim() !== "") {
    //   searchParameters.query.bool.filter.bool.must.push({
    //     match_phrase: { Brand: searchBrand.trim().toLowerCase() },
    //   });
    // }

    console.log("getElasticData", JSON.stringify(searchParameters));
    const invoices = [];
    let total = 0;
    if (!exportData) {
      let addMessage = firebase.functions().httpsCallable("getDenomSales");
      let result = await addMessage({
        text: searchParameters,
      });
      let sanitizedMessage = result.data.text;
      total = sanitizedMessage.hits.total.value;
      sanitizedMessage.hits.hits.map((data, index) => {
        invoices.push({ ...data._source, key: data._id });
      });
    } else {
      let addMessage = firebase.functions().httpsCallable("scrollData");
      let result = await addMessage({
        text: searchParameters,
        collection: "denomsales",
        scrollID: "",
      });

      let sanitizedMessage = result.data.text;
      total = sanitizedMessage.hits.total.value;
      sanitizedMessage.hits.hits.map((data, index) => {
        invoices.push({ ...data._source, key: data._id });
      });
      // console.log("getElasticData 0");

      if (total > size && exportData) {
        let scrollID = sanitizedMessage._scroll_id;
        searchParameters = {
          scroll: "9m",
          scroll_id: scrollID,
        };
        for (let index = 1; index < total / size; index++) {
          // console.log("getElasticData ", index);
          let addMessage = firebase.functions().httpsCallable("scrollData");
          let loopResult = await addMessage({
            text: searchParameters,
            scrollID: scrollID,
          });
          loopResult.data.text.hits.hits.map((data, index) => {
            invoices.push({ ...data._source, key: data._id });
          });
        }
      }
    }

    return {
      totalItemsCount: total,
      searchResult: invoices,
    };
  }

  async loadInvoiceDetailReport(
    storeList,
    from,
    size,
    searchTransactionNo,
    searchTransactiontype,
    searchTransactionFromDate,
    searchTransactionToDate,
    searchCustomerDetail,
    searchProductDetail,
    // searchDiscount,
    // searchTaxableAmount,
    // searchTaxSummary,
    forExport = false
  ) {
    this.setState({ loading: true });
    let gstinCustomFieldNo = this.getGSTINCustomField();

    let result = await this.getElasticData(
      this.props.user.user.RegistrationID,
      storeList,
      from,
      size,
      searchTransactionNo,
      searchTransactiontype,
      searchTransactionFromDate,
      searchTransactionToDate,
      searchCustomerDetail,
      searchProductDetail,
      forExport
    );

    this.setState({ totalItemsCount: result.totalItemsCount });
    // this.props
    //   .getInvoiceDetailReport(
    //     this.props.user.user.RegistrationID,
    //     storeList,
    //     from,
    //     this.state.itemsCountPerPage,
    //     searchTransactionNo,
    //     searchTransactiontype,
    //     searchTransactionFromDate,
    //     searchTransactionToDate,
    //     searchCustomerDetail,
    //     searchProductDetail,
    //     searchDiscount,
    //     searchTaxableAmount,
    //     searchTaxSummary
    //   )
    //   .then((result) => {
    let invoices = [];

    for (let index = 0; index < result.searchResult.length; index++) {
      const data = result.searchResult[index];
      // console.log('data', data)
      let invoice = {
        "Store Name ": data.StoreName,
        "Cash Register": data.CashRegisterName,
        "Customer Code": data.CustomerCode,
        "Customer Name": data.CustomerName,
        "Customer Mobile No.": data.CustomerPhoneNo,
        "Customer GSTIN": "",
      };

      if (gstinCustomFieldNo === 1) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField1")
          ? data.CustomerCustomField1
          : "";
      } else if (gstinCustomFieldNo === 2) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField2")
          ? data.CustomerCustomField2
          : "";
      } else if (gstinCustomFieldNo === 3) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField3")
          ? data.CustomerCustomField3
          : "";
      } else if (gstinCustomFieldNo === 4) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField4")
          ? data.CustomerCustomField4
          : "";
      } else if (gstinCustomFieldNo === 5) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField5")
          ? data.CustomerCustomField5
          : "";
      } else if (gstinCustomFieldNo === 6) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField6")
          ? data.CustomerCustomField6
          : "";
      }
      // invoice[this.state.customField1DisplayName] = data.hasOwnProperty('CustomerCustomField1') ? data.CustomerCustomField1 : ""
      // invoice[this.state.customField2DisplayName] = data.hasOwnProperty('CustomerCustomField2') ? data.CustomerCustomField2 : ""
      // invoice[this.state.customField3DisplayName] = data.hasOwnProperty('CustomerCustomField3') ? data.CustomerCustomField3 : ""
      // invoice[this.state.customField4DisplayName] = data.hasOwnProperty('CustomerCustomField4') ? data.CustomerCustomField4 : ""
      // invoice[this.state.customField5DisplayName] = data.hasOwnProperty('CustomerCustomField5') ? data.CustomerCustomField5 : ""
      // invoice[this.state.customField6DisplayName] = data.hasOwnProperty('CustomerCustomField6') ? data.CustomerCustomField6 : ""

      invoice["Transaction No"] = data.TransactionNo;
      invoice["Transaction Type"] = data.TransactionType;
      invoice["Transaction Date"] = new Date(data.TransactionDate)
        .toISOString()
        .split("T")[0];
      invoice.Cancelled = "No";
      if (data.CancellationReason) {
        invoice.Cancelled = "Yes";
      }
      invoice["Type"] = data.ProductType;
      invoice["HSNSAC Code"] = data.HSNSACCode;
      invoice["Brand"] = data.Brand ? data.Brand : "";
      invoice["Category"] = data.Category;
      invoice["Sub Category"] = data.SubCategory ? data.SubCategory : "";
      invoice["Item Code"] = data.SKU;
      invoice["BarCode"] = data.BarCode;
      invoice["Item Name"] = data.ProductName;
      invoice[this.state.productCustomField1DisplayName] = data.hasOwnProperty(
        "ProductCustomField1"
      )
        ? data.ProductCustomField1
        : "";
      invoice[this.state.productCustomField2DisplayName] = data.hasOwnProperty(
        "ProductCustomField2"
      )
        ? data.ProductCustomField2
        : "";
      invoice[this.state.productCustomField3DisplayName] = data.hasOwnProperty(
        "ProductCustomField3"
      )
        ? data.ProductCustomField3
        : "";
      invoice[this.state.productCustomField4DisplayName] = data.hasOwnProperty(
        "ProductCustomField4"
      )
        ? data.ProductCustomField4
        : "";
      invoice[this.state.productCustomField5DisplayName] = data.hasOwnProperty(
        "ProductCustomField5"
      )
        ? data.ProductCustomField5
        : "";
      invoice[this.state.productCustomField6DisplayName] = data.hasOwnProperty(
        "ProductCustomField6"
      )
        ? data.ProductCustomField6
        : "";
      invoice["MRP"] = data.MRP;
      invoice["Supply Price"] = data.hasOwnProperty("SupplyPrice")
        ? data.SupplyPrice
        : 0;
      invoice["Retail Price"] = data.RetailPrice;
      invoice["Qty"] = data.Qty;
      invoice["Tax Inclusive"] = data.TaxInclusive ? "Yes" : "No";
      invoice["Taxble Amount"] = data.TaxableAmount;
      invoice["Discount Per"] = data.DiscountPer;

      for (let index = 0; index < this.state.taxes.length; index++) {
        invoice[this.state.taxes[index].name] = "";
        invoice[this.state.taxes[index].perc] = "";
      }
      if (data.TaxComponentAmount) {
        data.TaxComponentAmount.map((tax) => {
          if (tax.TaxName !== "") {
            invoice[tax.TaxName] = tax.TaxAmount;
            invoice[tax.TaxName + "%"] = tax.TaxPercentage;
          }
        });
      }
      invoice["Sub Total"] = data.SubTotal;
      invoice["Total Tax"] = data.TotalTax;
      invoice["Discount Amount"] = data.DiscountAmount;
      invoice["Grand Total"] = data.Amount;

      invoices.push(invoice);
    }

    var col = [];
    for (var i = 0; i < invoices.length; i++) {
      for (var key in invoices[i]) {
        if (col.indexOf(key) === -1) {
          col.push(key);
        }
      }
    }

    var resultHTML = "<table class='table table-bordered'><thead><tr>";
    for (var i = 0; i < col.length; i++) {
      resultHTML += "<th>";
      resultHTML += col[i];
      resultHTML += "</th>";
    }
    resultHTML += "</tr></thead>";

    // ADD JSON DATA TO THE TABLE AS ROWS.
    resultHTML += "<tbody>";
    for (var i = 0; i < invoices.length; i++) {
      resultHTML += "<tr>";
      for (var j = 0; j < col.length; j++) {
        resultHTML += "<td>";
        resultHTML +=
          invoices[i][col[j]] == undefined ? 0 : invoices[i][col[j]];
        resultHTML += "</td>";
      }
      resultHTML += "</tr>";
    }
    resultHTML += "</tbody>";
    resultHTML += "</table>";
    //console.log(result);
    this.setState({ invoices: resultHTML, loading: false });
    //   });
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.onSearchClick();
    }
  }

  onClearSearch() {
    let storeList = [];
    storeList.push({ key: this.props.user.store.key });

    let selectedYear = new Date().getFullYear();
    let selectedMonth = new Date().getMonth();

    let searchTransactionFromDate = this.getMonthStartDate(
      selectedYear,
      selectedMonth
    );
    let searchTransactionToDate = this.getMonthEndDate(
      selectedYear,
      selectedMonth
    );

    this.setState({
      selectedYear: selectedYear,
      selectedMonth: selectedMonth,
      searchTransactionFromDate: searchTransactionFromDate,
      searchTransactionToDate: searchTransactionToDate,
      storeList: storeList,
      storeID: this.props.user.store.key,
      recordFrom: 0,
      searchTransactionNo: "",
      searchTransactiontype: "",
      searchCustomerDetail: "",
      searchProductDetail: "",
      //   searchDiscount: "",
      //   searchTaxableAmount: "",
      //   searchTaxSummary: "",
    });
    this.loadInvoiceDetailReport(
      storeList,
      0,
      this.state.itemsCountPerPage,
      "",
      "",
      searchTransactionFromDate,
      searchTransactionToDate,
      "",
      "",
      "",
      "",
      "",
      ""
    );
  }

  async onExportClick() {
    this.setState({ exportCalled: true, loading: true });
    let gstinCustomFieldNo = this.getGSTINCustomField();

    let result = await this.getElasticData(
      this.props.user.user.RegistrationID,
      this.state.storeList,
      0,
      1000,
      this.state.searchTransactionNo,
      this.state.searchTransactiontype,
      this.state.searchTransactionFromDate,
      this.state.searchTransactionToDate,
      this.state.searchCustomerDetail,
      this.state.searchProductDetail,
      true
    );

    // this.props
    //   .getInvoiceDetailReport(
    //     this.props.user.user.RegistrationID,
    //     this.state.storeList,
    //     0,
    //     10000,
    //     this.state.searchTransactionNo,
    //     this.state.searchTransactiontype,
    //     this.state.searchTransactionFromDate,
    //     this.state.searchTransactionToDate,
    //     this.state.searchCustomerDetail,
    //     this.state.searchProductDetail,
    //     // this.state.searchDiscount,
    //     // this.state.searchTaxableAmount,
    //     // this.state.searchTaxSummary
    //     true
    //   )
    //   .then((result) => {
    // console.log(result.searchResult);
    if (
      isNullOrUndefined(result.searchResult) ||
      result.searchResult.length === 0
    ) {
      this.props.getToastr("No Record Found");
      return;
    }
    let invoices = [];
    result.searchResult.map((data) => {
      let invoice = {
        "Store Name ": data.StoreName,
        "Cash Register": data.CashRegisterName,
        "Customer Code": data.CustomerCode,
        "Customer Name": data.CustomerName,
        "Customer Mobile No.": data.CustomerPhoneNo,
      };
      if (gstinCustomFieldNo === 1) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField1")
          ? data.CustomerCustomField1
          : "";
      } else if (gstinCustomFieldNo === 2) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField2")
          ? data.CustomerCustomField2
          : "";
      } else if (gstinCustomFieldNo === 3) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField3")
          ? data.CustomerCustomField3
          : "";
      } else if (gstinCustomFieldNo === 4) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField4")
          ? data.CustomerCustomField4
          : "";
      } else if (gstinCustomFieldNo === 5) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField5")
          ? data.CustomerCustomField5
          : "";
      } else if (gstinCustomFieldNo === 6) {
        invoice["Customer GSTIN"] = data.hasOwnProperty("CustomerCustomField6")
          ? data.CustomerCustomField6
          : "";
      }
      // invoice[this.state.customField1DisplayName] = data.hasOwnProperty('CustomerCustomField1') ? data.CustomerCustomField1 : ""
      // invoice[this.state.customField2DisplayName] = data.hasOwnProperty('CustomerCustomField2') ?  data.CustomerCustomField2 : ""
      // invoice[this.state.customField3DisplayName] = data.hasOwnProperty('CustomerCustomField3') ? data.CustomerCustomField3 : ""
      // invoice[this.state.customField4DisplayName] = data.hasOwnProperty('CustomerCustomField4') ? data.CustomerCustomField4 :""
      // invoice[this.state.customField5DisplayName] = data.hasOwnProperty('CustomerCustomField5') ? data.CustomerCustomField5 : ""
      // invoice[this.state.customField6DisplayName] = data.hasOwnProperty('CustomerCustomField6') ? data.CustomerCustomField6 : ""

      invoice["Transaction No"] = data.TransactionNo;
      invoice["Transaction Type"] = data.TransactionType;
      invoice["Transaction Date"] = new Date(data.TransactionDate)
        .toISOString()
        .split("T")[0];
      invoice.Cancelled = "No";
      if (data.CancellationReason) {
        invoice.Cancelled = "Yes";
      }
      invoice["Type"] = data.ProductType;
      invoice["HSNSAC Code"] = data.HSNSACCode;
      invoice["Brand"] = data.Brand ? data.Brand : "";
      invoice["Category"] = data.Category;
      invoice["Sub Category"] = data.SubCategory ? data.SubCategory : "";
      invoice["Item Code"] = data.SKU;
      invoice["BarCode"] = data.BarCode;
      invoice["Item Name"] = data.ProductName.replace(/,/g, "");
      invoice[this.state.productCustomField1DisplayName] = data.hasOwnProperty(
        "ProductCustomField1"
      )
        ? data.ProductCustomField1
        : "";
      invoice[this.state.productCustomField2DisplayName] = data.hasOwnProperty(
        "ProductCustomField2"
      )
        ? data.ProductCustomField2
        : "";
      invoice[this.state.productCustomField3DisplayName] = data.hasOwnProperty(
        "ProductCustomField3"
      )
        ? data.ProductCustomField3
        : "";
      invoice[this.state.productCustomField4DisplayName] = data.hasOwnProperty(
        "ProductCustomField4"
      )
        ? data.ProductCustomField4
        : "";
      invoice[this.state.productCustomField5DisplayName] = data.hasOwnProperty(
        "ProductCustomField5"
      )
        ? data.ProductCustomField5
        : "";
      invoice[this.state.productCustomField6DisplayName] = data.hasOwnProperty(
        "ProductCustomField6"
      )
        ? data.ProductCustomField6
        : "";
      invoice["MRP"] = data.MRP;
      invoice["Supply Price"] = data.hasOwnProperty("SupplyPrice")
        ? data.SupplyPrice
        : 0;
      invoice["Retail Price"] = data.RetailPrice;
      invoice["Qty"] = data.Qty;
      invoice["Tax Inclusive"] = data.TaxInclusive ? "Yes" : "No";
      invoice["Taxble Amount"] = data.TaxableAmount;
      invoice["Discount Per"] = data.DiscountPer;

      for (let index = 0; index < this.state.taxes.length; index++) {
        invoice[this.state.taxes[index].name] = 0;
        invoice[this.state.taxes[index].perc] = "";
      }
      if (data.TaxComponentAmount) {
        data.TaxComponentAmount.map((tax) => {
          if (tax.TaxName !== "") {
            invoice[tax.TaxName] = tax.TaxAmount;
            invoice[tax.TaxName + "%"] = tax.TaxPercentage;
          }
        });
      }
      invoice["Sub Total"] = data.SubTotal;
      invoice["Total Tax"] = data.TotalTax;
      invoice["Discount Amount"] = data.DiscountAmount;
      invoice["Grand Total"] = data.Amount;

      invoices.push(invoice);
    });
    const csvData = constatnts.objToCSV(invoices);
    this.setState({ loading: false, exportCalled: false });
    const csvBlob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(csvBlob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", "GST Report.csv");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    //   });
  }

  onSearchClick() {
    this.setState({ searchFrom: 0, loading: true });
    this.loadInvoiceDetailReport(
      this.state.storeList,
      0,
      this.state.itemsCountPerPage,
      this.state.searchTransactionNo,
      this.state.searchTransactiontype,

      this.state.searchTransactionFromDate,
      this.state.searchTransactionToDate,
      this.state.searchCustomerDetail,
      this.state.searchProductDetail
      //   this.state.searchDiscount,
      //   this.state.searchTaxableAmount,
      //   this.state.searchTaxSummary
    );
  }

  onStoreChange(e) {
    let storeList = [];
    console.log("key", e.target.value);
    if (e.target.value != "") {
      storeList.push({ key: e.target.value });
    } else {
      for (let i = 0; i < this.state.stores.length; i++) {
        const store = this.state.stores[i];
        storeList.push({ key: store.key });
      }
    }
    console.log("storeList", JSON.stringify(storeList));
    this.setState({ storeList: storeList, storeID: e.target.value });
  }

  render() {
    return (
      <div className="content-wrapper">
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box ">
                <div className="box-header with-border">
                  <div className="row">
                    <div className="col-md-6 col-xs-9">
                      <font style={{ fontSize: "30px" }}>
                        GSTR1 - Transaction Line Item Wise
                      </font>
                    </div>
                    <div className="col-md-6 col-xs-3">
                      <button
                        type="cancel"
                        className="btn btn-default pull-right btn-flat"
                        style={{ marginTop: "5px", marginLeft: "10px" }}
                        onClick={() =>
                          this.props.history.push({
                            pathname: "/home/reports/allreport",
                          })
                        }
                      >
                        <i className="fa fa-arrow-left"></i> Back
                      </button>
                    </div>
                  </div>
                </div>
                <div className="box-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label>Store Name</label>
                      <select
                        className="form-control"
                        value={this.state.storeID}
                        onChange={this.onStoreChange}
                      >
                        {this.state.stores
                          .filter((e) => !e.IsDeleted)
                          .map((store) => (
                            <option value={store.key}>
                              {store.StoreCode}-{store.StoreName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Year</label>
                        <select
                          type="text"
                          className="form-control"
                          value={this.state.selectedYear}
                          onChange={this.onYearChange}
                        >
                          {this.state.years.map((e) => (
                            <option value={e}>{e}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Month</label>
                        <select
                          type="text"
                          className="form-control"
                          value={this.state.selectedMonth}
                          onChange={this.onMonthChange}
                        >
                          {this.state.months.map((e) => (
                            <option value={e.Month}>{e.MonthName}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Transaction Type</label>
                        <select
                          type="text"
                          className="form-control"
                          onChange={(evt) =>
                            this.setState({
                              searchTransactiontype: evt.target.value,
                            })
                          }
                        >
                          <option value="">All</option>
                          {this.props.config.TransactionTypes.filter(
                            (e) => e.Module === "sales" && !e.IsDeleted
                          ).map((e) => (
                            <option value={e.key}>{e.TransactionType}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Transaction No</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(evt) =>
                            this.setState({
                              searchTransactionNo: evt.target.value,
                            })
                          }
                          value={this.state.searchTransactionNo}
                          onKeyPress={this.handleKeyPress}
                        />
                      </div>
                    </div>
                    {/* <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Transaction From</label>
                                            <input type="date" className="form-control"
                                                onChange={(evt) => this.setState({ searchTransactionFromDate: evt.target.value })}
                                                value={this.state.searchTransactionFromDate}
                                                onKeyPress={this.handleKeyPress} />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Transaction To</label>
                                            <input type="date" className="form-control"
                                                onChange={(evt) => this.setState({ searchTransactionToDate: evt.target.value })}
                                                value={this.state.searchTransactionToDate}
                                                onKeyPress={this.handleKeyPress} />
                                        </div>
                                    </div> */}
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Customer Name,Code,Phone Number,Email</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(evt) =>
                            this.setState({
                              searchCustomerDetail: evt.target.value,
                            })
                          }
                          value={this.state.searchCustomerDetail}
                          onKeyPress={this.handleKeyPress}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Product Name,Code,</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(evt) =>
                            this.setState({
                              searchProductDetail: evt.target.value,
                            })
                          }
                          value={this.state.searchProductDetail}
                          onKeyPress={this.handleKeyPress}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12" style={{ marginTop: "-25px" }}>
                      <button
                        type="button"
                        className="btn btn-primary btn-flat btn-md pull-right"
                        style={{ marginTop: "25px", marginLeft: "5px" }}
                        onClick={this.onSearchClick}
                        disabled={
                          this.state.searchTransactionFromDate === "" ||
                          this.state.searchTransactionToDate === ""
                        }
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-default btn-flat btn-md pull-right"
                        style={{ marginTop: "25px" }}
                        onClick={this.onClearSearch}
                      >
                        Clear
                      </button>
                      <button
                        className="btn btn-default btn-flat btn-md pull-right"
                        style={{ marginTop: "25px", marginRight: "5px" }}
                        onClick={this.onExportClick}
                      >
                        {" "}
                        Export <i className="fa fa-download "></i>
                      </button>
                    </div>
                  </div>
                  <br></br>
                  {this.state.loading && <Loader show={this.state.loading} />}
                  {!this.state.loading && (
                    <div
                      style={{ width: "auto", overflowX: "auto" }}
                      className="scroll2"
                    >
                      {ReactHtmlParser(this.state.invoices)}
                    </div>
                  )}
                  {this.state.totalItemsCount > 0 && (
                    <div className="col-md-12">
                      <div className="pull-left" style={{ marginTop: "25px" }}>
                        {this.state.paginationStatus}
                      </div>
                      <div className="pull-right">
                        <Pagination
                          activePage={this.state.activePage} //this.state.activePage
                          itemsCountPerPage={this.state.itemsCountPerPage}
                          totalItemsCount={this.state.totalItemsCount}
                          pageRangeDisplayed={2}
                          onChange={this.handlePageChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(InvoiceDetailList1);
